import {IListItem} from '@/entities';

export enum AccountRole {
    Superadmin = 0,
    Admin = 5,
    Company = 10,
    Agent = 20
}

export function translateAccountRole(role: AccountRole): string {
    switch (role) {
        case AccountRole.Superadmin:
            return 'Superadmin';
        case AccountRole.Admin:
            return 'Admin';
        case AccountRole.Company:
            return 'Company';
        case AccountRole.Agent:
            return 'Agent';
        default:
            return 'role';
    }
}

export function getOptionListAccountRoles(): IListItem[] {
    return [
        { heading: 'All Roles', value: null },
        { heading: translateAccountRole(AccountRole.Superadmin), value: AccountRole.Superadmin },
        { heading: translateAccountRole(AccountRole.Admin), value: AccountRole.Admin },
        { heading: translateAccountRole(AccountRole.Company), value: AccountRole.Company },
        { heading: translateAccountRole(AccountRole.Agent), value: AccountRole.Agent },
    ];
}
